export const DASHBOARD_FETCH_TOTALS = 'DASHBOARD_FETCH_TOTALS';
export const DASHBOARD_FETCH_TOTALS_SUCCESS = 'DASHBOARD_FETCH_TOTALS_SUCCESS';
export const DASHBOARD_FETCH_TOTALS_FAIL = 'DASHBOARD_FETCH_TOTALS_FAIL';

export const DASHBOARD_CLEAR_TOTALS = 'DASHBOARD_CLEAR_TOTALS';
